import { apiAxiosCMS } from 'services/api';
import { BannersCarroselProps } from 'types/BannersCarroselProps';

interface RespReqProps {
	isSuccess: boolean;
	bannerSaved: BannersCarroselProps | null;
}

export async function addBannerReq(
	form: BannersCarroselProps,
	setIsLoad: React.Dispatch<React.SetStateAction<boolean>>,
	setMessage: React.Dispatch<React.SetStateAction<string>>,
	handleNotify: any
) {
	const respReq: RespReqProps = {
		isSuccess: false,
		bannerSaved: null
	};

	setMessage('Salvando banner...');
	setIsLoad(true);

	const payload: any = { ...form };

	delete payload.id;

	await apiAxiosCMS
		.post('/banner', payload)
		.then((res) => {
			respReq.isSuccess = true;
			respReq.bannerSaved = res.data;
			handleNotify('Banner adicionado com sucesso.', 'success');
		})
		.catch((error) => {
			respReq.isSuccess = false;
			respReq.bannerSaved = null;
			handleNotify('Erro ao adicionar banner.', 'error');
			console.error('✌️error --->', error);
		});

	setIsLoad(false);

	return respReq;
}

export async function editBannerReq(
	bannerToEdir: BannersCarroselProps,
	form: BannersCarroselProps,
	setIsLoad: React.Dispatch<React.SetStateAction<boolean>>,
	setMessage: React.Dispatch<React.SetStateAction<string>>,
	handleNotify: any
) {
	const respReq = {
		isSuccess: false
	};

	setMessage('Editando banner');
	setIsLoad(true);

	const payload: any = { ...form };

	delete payload.id;

	await apiAxiosCMS
		.patch(`/banner/${bannerToEdir.id}`, payload)
		.then(() => {
			respReq.isSuccess = true;
			handleNotify('Banner adicionado com sucesso.', 'success');
		})
		.catch((error) => {
			respReq.isSuccess = false;
			handleNotify('Erro ao adicionar banner.', 'error');
			console.error('✌️error --->', error);
		});

	setIsLoad(false);

	return respReq;
}
